import styled from 'styled-components';

import {
  Divider as SemanticDivider,
  Grid as SemanticGrid,
  Icon as SemanticIcon,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent, colors } from '@playbookux/playbook-web-core';

const { LINK_COLOR } = colors;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 30px 10px;
`;

const Title = styled(TextLayoutComponent.Bold)`
  font-size: 18px;
  margin: 20px 20px 0 20px;
  text-align: left;
`;

const Divider = styled(SemanticDivider)`
  &&&& {
    border-top: 2px solid #EDEDED;
    margin: 0 20px 28px 20px;
  }
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  text-align: left;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    padding: 0 10px 0 10px;
    text-align: left;
    margin-bottom: 10px;
  }
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    margin-bottom: -5px;
    margin-top: -20px;
    text-align: left;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&& {
    font-size: 14px;
    font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
    margin: 0 10px 0 10px;
    text-align: left;
    b {
      font-weight: 500;
    }
  }
`;

const Icon = styled(SemanticIcon)`
  &&& {
    color: ${LINK_COLOR};
    cursor: pointer;
  }
`;

const ColumnName = styled(TextLayoutComponent.Bold)``;

const ColumnValue = styled(TextLayoutComponent)``;

export {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Divider,
  Grid,
  Icon,
  Row,
  Title,
};
